import { useState } from "react";
import AddGambarDepan from "./AddGambarDepan";
import AddGambarSekolah from "./AddGambarSekolah";
import AddKegiatan from "./AddKegiatan";
import AddPrestasi from "./AddPrestasi";

const Gambar = () => {
  const [active, setActive] = useState("sekolah"); // default tampilkan AddGambarSekolah

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-2xl mx-auto text-center mb-6">
        <h2 className="text-2xl font-semibold mb-4">Manajemen Gambar</h2>
        <div className="flex justify-center gap-4 mb-4">
          <button
            onClick={() => setActive("sekolah")}
            className={`px-4 py-2 rounded ${
              active === "sekolah"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            Gambar Sekolah
          </button>
          <button
            onClick={() => setActive("depan")}
            className={`px-4 py-2 rounded ${
              active === "depan"
                ? "bg-green-600 text-white"
                : "bg-white border border-green-600 text-green-600"
            }`}
          >
            Gambar Depan
          </button>
          <button
            onClick={() => setActive("prestasi")}
            className={`px-4 py-2 rounded ${
              active === "prestasi"
                ? "bg-green-600 text-white"
                : "bg-white border border-green-600 text-green-600"
            }`}
          >
            Prestasi
          </button>
          <button
            onClick={() => setActive("kegiatan")}
            className={`px-4 py-2 rounded ${
              active === "kegiatan"
                ? "bg-green-600 text-white"
                : "bg-white border border-green-600 text-green-600"
            }`}
          >
            Kegiatan
          </button>
        </div>
      </div>

      {active === "sekolah" && <AddGambarSekolah />}
      {active === "depan" && <AddGambarDepan />}
      {active === "prestasi" && <AddPrestasi />}
      {active === "kegiatan" && <AddKegiatan />}
    </div>
  );
};

export default Gambar;
